import { Typography } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { WhTaskEdit } from 'components/wh-tasks/wh-task-edit';
import { WhTaskItemsAdd } from 'components/wh-tasks/wh-task-items-add';
import { WhTaskStatusEdit } from 'components/wh-tasks/wh-task-status-edit';
import { WhTaskStatusTag } from 'components/wh-tasks/wh-task-status-tag';
import { WhTaskStickerGenerator } from 'components/wh-tasks/wh-task-sticker-generator';
import { WhTaskTypeTag } from 'components/wh-tasks/wh-task-type-tag';
import type { IWhTaskPageHeaderProps } from './types';

export const WhTaskPageHeader = (props: IWhTaskPageHeaderProps) => {
  const { whTask } = props;

  return (
    <PageHeader
      title={whTask.compositeId}
      extra={[
        <WhTaskStickerGenerator key='wh-task-sticker-generator' whTaskId={whTask.id} />,
        <WhTaskItemsAdd key='wh-task-items-add' whTaskId={whTask.id} />,
        <WhTaskStatusEdit key='wh-task-status-edit' whTask={whTask} />,
        <WhTaskEdit key='wh-task-edit' whTask={whTask} />,
      ]}
      tags={[
        <WhTaskTypeTag key='wh-task-type' type={whTask.type} />,
        <WhTaskStatusTag key='wh-task-status' status={whTask.status} />,
      ]}
      onBack={() => history.back()}>
      <Typography.Text>{whTask.clientOrderNumber}</Typography.Text>
    </PageHeader>
  );
};
